import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { CarouselModule } from 'ngx-owl-carousel-o';
import { SigninComponent } from './signin/signin.component';
import { LoginService } from './services/login.service';
import { FormsModule } from '@angular/forms';
import { HttpClientModule } from '@angular/common/http';
import { ToastrModule } from 'ngx-toastr';
import { SharedModule } from './shared/shared.module';
import { ErrorPageComponent } from './shared/components/errorpage/error-page.component';
import { NariComponent } from './nari/nari.component';

@NgModule({
    declarations: [AppComponent, SigninComponent, ErrorPageComponent, NariComponent],
    imports: [
        BrowserModule,
        AppRoutingModule,
        CarouselModule,
        BrowserAnimationsModule,
        FormsModule,
        HttpClientModule,
        ToastrModule.forRoot(),
        SharedModule
    ],
    providers: [LoginService],
    bootstrap: [AppComponent]
})
export class AppModule {}
